<template>
  <div class="pa-7" id="achievement">
    <!--タイトル-->
    <span class="subHead">
    {{ title }}
    </span>
    <v-icon
    class="mb-2"
    color="blue-grey darken-2">
      {{ icon }}
    </v-icon>

    <!--内容-->
          <div class="">
          <v-col v-for="(item, i) in contents"
      :key="i">
              <v-card-text class="box" style="white-space:pre-wrap; word-wrap:break-word; margin-top:-1rem;">
                {{ item.description }}
              </v-card-text>
              </v-col>
              </div>
               <div style="text-align:center; color:#C62828;">試用など各種ご相談お問い合わせは、こちらからお願いいたします。</div>
  </div>
</template>

<style>
.subHead {
  font-size: 25px;
}
.head2 {
  font-size: 20px;
  border-left: inset 6px#99CCFF;
  padding-left: 8px;
  margin-bottom: 8px;
}
hr{
    max-width: 1200px;
}
#achievement{
    margin-top: -4rem;
}
</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: '実績',
      // タイトル横のアイコン
      icon: 'mdi-book',
      contents: [
        {
          descriptiontitle: '',
          // 説明文
          description: `
全国大会 演題数 102
全国大会 演題数 194
地方大会 演題数 249`
        }
      ]
    }
  }
}
</script>
